module.exports = __webpack_public_path__ + "img/17_28.5c74a181.png";